import { useSectionVisible } from 'appContainer/SectionVisible';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { NOT_SUBMITTED_STATUSES } from 'types/Claims';
import { SECTIONS } from 'types/SectionsVisibility';

export const useClaimHook = () => {
	const { claimData } = useSelector((store: RootState) => store.claim);
	const { claimReturnStatuses } = useSelector((store: RootState) => store.form);

	const showTaxColumns = useSectionVisible(
		SECTIONS.NEWCLAIM_CALCULATE_TAX_COLUMNS,
		{ customLayout: claimData.customLayout || null },
	);

	const showInternalNote =
		claimData.status.id === 8 &&
		claimData.status.internalNote &&
		!claimData.status.reasonCode;

	const showPendingNote =
		[3, 18].includes(claimData.status.id) && claimData.status.internalNote;

	const showRejectedNote =
		[8].includes(claimData.status.id) &&
		claimData.status.internalNote &&
		claimData.status.reasonCode;

	const showReturnStatus = !!(
		claimData.returnDetail?.status &&
		claimReturnStatuses.map(e => e.code).includes(claimData.returnDetail?.status)
	);

	const enableClaimReturn =
		!NOT_SUBMITTED_STATUSES.includes(claimData.status.id) && !showReturnStatus;

	return {
		showTaxColumns,
		showInternalNote,
		showPendingNote,
		showReturnStatus,
		showRejectedNote,
		enableClaimReturn,
	};
};
